function DeleteVariableModalController(stateService) {
    const ctrl = this;
  
    ctrl.$onInit = async() => {
        ctrl.variable = ctrl.resolve.variable;
        console.log("Delete modal controller variable:");
        console.log(ctrl.variable);
        
        //ctrl.workspaceId = ctrl.resolve.workspaceId;
    };
  
    ctrl.submit = () => {
      ctrl.close({ $value: ctrl.variable.id });
    };
  
    ctrl.cancel = () => {
      ctrl.dismiss({ $value: 'cancel' });
    };
  }
  
  angular
    .module('pis-tool.module')
    .controller('DeleteVariableModalController', DeleteVariableModalController);
  